import { render, staticRenderFns } from "./IndustryAccidentManage.vue?vue&type=template&id=26dd2380&scoped=true&"
import script from "./IndustryAccidentManage.vue?vue&type=script&lang=js&"
export * from "./IndustryAccidentManage.vue?vue&type=script&lang=js&"
import style0 from "./IndustryAccidentManage.vue?vue&type=style&index=0&id=26dd2380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dd2380",
  null
  
)

export default component.exports